import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { selectUserData } from '../../reducers/userDataReducer'
import './incident-reports.scss'

const IncidentReports = () => {
  const { t } = useTranslation(['incident-reports'])
  const userData = useSelector(selectUserData)
  const userEmail = userData?.user?.email || ''

  return (
    <div className="incident-reports">
      <div className="incident-reports__container">
        <iframe
          src={`https://elevateoshub.com/incidents?email=${encodeURIComponent(userEmail)}`}
          className="incident-reports__iframe"
          title={t('incident-reports:title')}
          frameBorder="0"
          allowFullScreen
        />
      </div>
    </div>
  )
}

export default IncidentReports
